var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "example-header hidden-print" }, [
    _c("div", { staticClass: "header-top" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "logo" }, [
          _c(
            "div",
            { staticClass: "logo1" },
            [
              _c(
                "router-link",
                { attrs: { to: { name: "Start" }, exact: "" } },
                [
                  _c("img", {
                    attrs: {
                      src: "/static/images/logo.png",
                      width: "117",
                      height: "61",
                      border: "0",
                      alt: "GS1 Germany Logo"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "large hidden-xs hidden-sm" }, [
                _c("strong", [_vm._v(_vm._s(_vm.$t("title")))]),
                _c("br"),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("provided_by")) +
                    "\n          "
                )
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { right: "0", position: "absolute" } }, [
          _c(
            "button",
            {
              staticClass: "btn btn-xs btn-secondary",
              staticStyle: { "margin-top": "15px" },
              attrs: { role: "button", tag: "button" },
              on: { click: _vm.logout }
            },
            [_vm._v("\n          Logout\n        ")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "navigation" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "nav",
          {
            staticClass: "navbar yamm navbar-default",
            attrs: { role: "navigation" }
          },
          [
            _c("div", { staticClass: "navbar-header" }, [
              _c(
                "div",
                { staticClass: "logo1 visible-xs" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "Start" }, exact: "" } },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/images/logo.png",
                          width: "117",
                          height: "61",
                          border: "0",
                          alt: "GS1 Germany Logo"
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "secondary-nav" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-primary logout-button",
                    attrs: { type: "button" },
                    on: { click: _vm.logout }
                  },
                  [_vm._v("\n              Logout\n            ")]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "navbar-collapse collapse",
                attrs: { id: "navbar-collapse-example" }
              },
              [
                _c(
                  "ul",
                  { staticClass: "nav navbar-nav" },
                  [
                    _c(
                      "router-link",
                      {
                        class: {
                          active:
                            _vm.$route.path.startsWith("/companies") ||
                            _vm.$route.path.startsWith("/result")
                        },
                        attrs: { tag: "li", to: { name: "Start" }, exact: "" }
                      },
                      [_c("a", [_vm._v(_vm._s(_vm.$t("menu.search")))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { attrs: { tag: "li", to: { name: "Token" } } },
                      [_c("a", [_vm._v(_vm._s(_vm.$t("menu.token")))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { attrs: { tag: "li", to: { name: "Bulk" } } },
                      [_c("a", [_vm._v(_vm._s(_vm.$t("menu.bulk")))])]
                    ),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://www.gs1-germany.de/serviceverzeichnis/verified-by-gs1/",
                            target: "_blank",
                            rel: "noopener"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("menu.about")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c("LanguageSelector", {
                          staticStyle: { "margin-top": "20px" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "header-bottom visible-xs visible-sm" }, [
      _c("div", { staticClass: "container" }, [
        _c("strong", [_vm._v(_vm._s(_vm.$t("title")))]),
        _c("br"),
        _vm._v("\n      " + _vm._s(_vm.$t("provided_by")) + "\n    ")
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggle collapsed",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbar-collapse-example"
        }
      },
      [
        _c("span", { staticClass: "icon-bar" }),
        _c("span", { staticClass: "icon-bar" }),
        _c("span", { staticClass: "icon-bar" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 